import { memo } from "react";
import { Grid, styled } from "@mui/material";
import AgentsGroupSelected from "./AgentsGroupSelected";
import useModal from "@rf/base/modal/useModal";
import AgentsSelectV2Modal from "./AgentsSelectV2Modal";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { useFormContext } from "react-hook-form";
import MxTypography from "@rf-l1/MxTypography";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import MxErrorMessage from "@rf-l1/form/MxErrorMessage";

const AgentsSelector = () => {
  const { modal } = useModal();
  const { control, formState } = useFormContext();

  const openModal = () => {
    modal({
      template: <AgentsSelectV2Modal />,
      data: {
        control
      },
      options: {
        disableBackdropClick: true,
        disableCloseButton: true,
        disableEscapeKeyDown: true,
        title: "Agregar agente(s)",
        size: {
          xs: { width: "100%", height: "100%" },
          sm: { width: "100%", height: "100%" },
          md: { width: "480px", minHeight: "430px" }
          // lg: { width: "480px", minHeight: "480px" },
          // xl: { width: "480px", minHeight: "480px" }
        }
      }
    });
  };

  return (
    <ContentBroker container columnGap={3}>
      {/* Header now shows title + selected agents and an edit button */}
      <Grid item xs={12} height={10}>
        <MxTypography
          textAlign="center"
          color="grey.800"
          variant="caption"
          fontWeight={500}
        >
          Agentes captadores
        </MxTypography>
      </Grid>

      <AgentsGroupSelected />

      <Grid item xs="auto">
        <MxButton2 variant="contained" onClick={openModal} textColor="common.white">
          Seleccionar agente
        </MxButton2>
      </Grid>

      <Grid container item xs={12} textAlign={"center"} justifyContent="center">
        {(formState?.errors as any)?.[CPropertyFormKeys.brokers_property]
          ?.message && (
          <MxErrorMessage
            error={
              (formState.errors as any)[CPropertyFormKeys.brokers_property].message
            }
          />
        )}
      </Grid>
    </ContentBroker>
  );
};
export default memo(AgentsSelector);

const ContentBroker = styled(Grid)(({ theme }) => ({
  backgroundColor: "var(--m-color-blue-01)",
  width: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 150,
  marginLeft: "auto",
  [theme.breakpoints.up("lg")]: {
    borderBottomLeftRadius: 10,
    borderTopRightRadius: 10
  },
  [theme.breakpoints.down("lg")]: {
    borderRadius: 0,
    width: "100%",
    rowGap: 15,
    padding: 10,
    display: "flex"
  }

  // width: "auto",
  // height: "5rem",
  // display: "grid",
  // alignContent: "center",
  // alignItems: "center",
  // gridTemplateColumns: "1fr auto",
  // padding: "0 1rem",
  // borderTopLeftRadius: "0.9375rem",
  // "& .icon ": {
  //   display: "none"
  // },
  // "&:has(.MuiBadge-root:hover) .icon ": {
  //   display: "block"
  // },
  // [theme.breakpoints.down("lg")]: {
  //   borderTopLeftRadius: "0",
  //   borderTopRightRadius: "0"
  // }
}));

const TitleText = styled("span")(({ theme }) => ({
  color: theme.palette.grey[700],
  fontWeight: 700,
  fontSize: 12
}));
